import { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router';

export default (openByDefault = false) => {
  const [chatbotIsOpen, setChatbotIsOpen] = useState(openByDefault);
  const [isMinimized, setIsMinimized] = useState(true);
  const isSmallScreen = useMediaQuery('(max-width:1100px)');
  const location = useLocation();
  const getProjectId = () => {
    const pathSegments = location.pathname.split('/');
    const projectIndex = pathSegments.indexOf('projects');
    if (projectIndex !== -1 && pathSegments.length > projectIndex + 1) {
      return pathSegments[projectIndex + 1];
    }
    return null;
  };

  const projectId = getProjectId();

  const toggleChatbotIsMinimized = () => {
    setIsMinimized(!isMinimized);
  };
  const toggleChatbotIsOpen = () => {
    setChatbotIsOpen(!chatbotIsOpen);
    setIsMinimized(false);
  };

  return {
    chatbotIsOpen,
    isMinimized,
    isSmallScreen,
    projectId,
    toggleChatbotIsMinimized,
    toggleChatbotIsOpen,
  };
};
